// extracted by mini-css-extract-plugin
export default {"box_container":"estilos_box_container__9OwNl","fab_add":"estilos_fab_add__CG2SB"};